import { Transactions } from '../pages/dashboard/payments/interfaces/Transactions';
import { useGetQuery } from './useGetQuery';
import { useQueryClient } from 'react-query';
import { FilterParams } from '../interfaces/Filter';

const defaultParams: FilterParams = {
    page: 1,
    size: 20
};

export const useTransactions = (initialParams?: FilterParams) => {
    const queryClient = useQueryClient();

    const params = initialParams || defaultParams;

    const {
        isLoading,
        entries: transactionsList,
        isFetching,
        paging
    } = useGetQuery<Transactions[]>({
        url: '/transactions',
        cacheKey: `transactions-${params?.page}`,
        params: { ...params }
    });

    const invalidateTransactionsCache = () => {
        queryClient.invalidateQueries({ queryKey: ['transactions', params] });
    };

    return {
        isLoading,
        transactionsList,
        invalidateTransactionsCache,
        isFetching,
        transactionPaging: paging
    };
};
